module.exports = __webpack_public_path__ + "static/media/icon_send_white.d0bfec4f.svg";